import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as commonActionCreator from '../../../redux/actions/data-action';
import { DEFAULT_RESPONSE, TaskType, SubTaskType, getTasks } from '../../../redux/actions/data-action';
import { TaskContent, TaskQuestionBox, TaskOptionsColumn, TaskButton, TaskOptionsContainer, TaskButtonList, TaskButtonListHorizontal } from '../common/task-controls';
import createTask from './tasks';
import history from '../../../routes/history';
import { Box } from '../../../third-party-components/material-ui';

const ITEM_DELAY = 0.5;

export class RatingScaleTask extends Component {
    constructor(props) {
        super(props);

        this.state = {
            lastClicked: new Date()
        };

        this.handleResponseClick = this.handleResponseClick.bind(this);
        this.isOptionSelected = this.isOptionSelected.bind(this);
        this.canGoNext = this.canGoNext.bind(this);
        this.getCompletedPercentage = this.getCompletedPercentage.bind(this);
    }

    handleResponseClick(response) {
        const { task, taskType, subTaskType, setTaskResponse } = this.props;

        // Delays the item selection by factor of (ITEM_DELAY) seconds at the top of the code
        var curClicked = new Date();
        var lastClicked = this.state.lastClicked;

        if ((curClicked.getTime() - lastClicked.getTime()) / 1000 < ITEM_DELAY) {
            return;
        }

        if(this.isOptionSelected(response))
        {
            setTaskResponse(task, taskType, subTaskType, DEFAULT_RESPONSE);
            return;
        }

        setTaskResponse(task, taskType, subTaskType, response);
        //this.forceUpdate();
        if(this.canGoNext(task)) {
            this.goNext();
            // this.setState({textFadeStyle:'fade-in-style'});
        }

        this.setState({lastClicked: new Date()})
    }

    goNext() {
      const { tasks, taskLink, nextLink, saveData, saveScreenDuration } = this.props;

      const currentIndex = this.getCurrentIndex();

      if (currentIndex < tasks.length - 1) {
          //saveData();
          saveScreenDuration();
          history.push(`${taskLink}/${currentIndex + 2}`);
      } else {
        //   if (nextLink.includes("Tasks")) {
        //       saveData();
        //   }
          history.push(nextLink);
      }

      this.forceUpdate();
  }

  getCurrentTask() {
    const { tasks } = this.props;
    const currentIndex = this.getCurrentIndex();
    return tasks[currentIndex];
}

getCurrentIndex() {
    let currentIndex = 0;

    const { match } = this.props;
    const index = match.params.index;

    if (index !== undefined) {
        currentIndex = index - 1;
    }

    return currentIndex;
}

    isOptionSelected(response) {
        const { task } = this.props;
        return this.hasReponse(task) && task.response[0] === response;
    }

    canGoNext(task) {
        if (this.hasReponse(task) && this.hasDefaultResponse(task) === false) {
            return true;
        }

        return false;
    }

    getCompletedPercentage(tasks) {
        let countResponses = 0;

        tasks.forEach(task => {
            if (this.hasReponse(task)) {
                countResponses += 1;
            }
        });

        return (countResponses / tasks.length) * 100;
    }

    hasReponse(task) {
        return task && task.response && task.response.length > 0;
    }

    hasDefaultResponse(task) {
        return this.hasReponse(task) && task.response[0] === DEFAULT_RESPONSE;
    }

    componentDidMount() {
    }

    render() {
      const { task, taskContentClassName } = this.props;

      var question = task.question;
        return (
          <TaskContent className={`ratings-task-content ${taskContentClassName}`}>
              <div className="task-question-container">
                <TaskQuestionBox className="ratings-question-box">
                    {{__html: question}}
                </TaskQuestionBox>
              </div>
              <TaskOptionsContainer className="ratings-options-container">
              <TaskButtonList className="faces-options"
                      options={task.options}
                      isSelected={this.isOptionSelected}
                      onClick={this.handleResponseClick} />
              </TaskOptionsContainer>
            </TaskContent>
        )
    }
}

const mapStateToProps = (state, ownState) => ({
    tasks : getTasks(state.data.tasks, TaskType.RATING, SubTaskType.TASKS),
    taskType: TaskType.RATING,
    subTaskType: SubTaskType.TASKS,
    versionID: state.data.versionID
})

export default connect(mapStateToProps, Object.assign({}, commonActionCreator))(createTask(RatingScaleTask))